import jQuery from "jquery";
import html2canvas from 'html2canvas';
import { jsPDF } from "jspdf";
export class Helpers {
    static sortAsc(array, field) {
        if (array) {
            array.sort((a, b) => {
                if (a[field] < b[field]) {
                    return -1;
                }
                else if (a[field] > b[field]) {
                    return 1;
                }
                else {
                    return 0;
                }
            });
        }
    }
    static getParameterByName(name, url = window.location.href) {
        name = name.replace(/[\[\]]/g, "\\$&");
        var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"), results = regex.exec(url);
        if (!results)
            return null;
        if (!results[2])
            return "";
        return decodeURIComponent(results[2].replace(/\+/g, " "));
    }
    static switchUserType(type) {
        switch (type) {
            case "EMPLOYEE":
                return "DIPENDENTE";
                break;
            case "VISITOR":
                return "OSPITE";
                break;
            case "VIP":
                return "VIP";
                break;
            default:
                return "";
                break;
        }
    }
    static switchHealthParameter(parameter) {
        switch (parameter) {
            case "CONNECTIVITY_CHECK":
                return "CONNETTIVITA'";
                break;
            default:
                return "";
                break;
        }
    }
    static getPolicyDescription(policy) {
        switch (policy) {
            case "UNBOUND":
                return "La policy è indipendente dall'orario della prenotazione o dell'invito";
                break;
            case "VISITOR_ALLOW":
                return "Transito consentito al visitatore";
                break;
            case "BOUND":
                return "La policy è dipendente dall'orario della prenotazione o dell'invito";
                break;
            case "VISITOR_REQUIRE_CHECKIN":
                return "Al visitatore è richiesto il check-in prima di poter transitare";
                break;
            default:
                return "";
                break;
        }
    }
    static findGate(gates, id) {
        return gates.filter(x => x.id === id);
    }
    static sortDays(days) {
        const sorter = {
            "Lun": 1,
            "Mar": 2,
            "Mer": 3,
            "Gio": 4,
            "Ven": 5,
            "Sab": 6,
            "Dom": 7
        };
        days.sort((a, b) => {
            a = a.split(" ")[0];
            b = b.split(" ")[0];
            return sorter[a] - sorter[b];
        });
        return days;
    }
    static formatOpeningHours(openingDaysHours) {
        openingDaysHours = openingDaysHours.map(x => this.formatDayOpeningHours(x));
        openingDaysHours = this.sortDays(openingDaysHours);
        let days = [];
        let hours = [];
        openingDaysHours.forEach(x => hours.push(x.substr(4, 11)));
        openingDaysHours.forEach(x => days.push(x.substr(0, 3)));
        if (hours.every(x => x === hours[0])) {
            openingDaysHours = [`${days}: ${hours[0]}`]; //if all days have the same opening hours get a simplify string
        }
        return openingDaysHours;
    }
    static formatDayOpeningHours(openingDayHours) {
        let openingHours = openingDayHours.trim().split(", ");
        switch (openingHours[0]) {
            case "MONDAY":
                openingDayHours = openingDayHours.replace(openingHours[0], "Lun");
                break;
            case "TUESDAY":
                openingDayHours = openingDayHours.replace(openingHours[0], "Mar");
                break;
            case "WEDNESDAY":
                openingDayHours = openingDayHours.replace(openingHours[0], "Mer");
                break;
            case "THURSDAY":
                openingDayHours = openingDayHours.replace(openingHours[0], "Gio");
                break;
            case "FRIDAY":
                openingDayHours = openingDayHours.replace(openingHours[0], "Ven");
                break;
            case "SATURDAY":
                openingDayHours = openingDayHours.replace(openingHours[0], "Sab");
                break;
            case "SUNDAY":
                openingDayHours = openingDayHours.replace(openingHours[0], "Dom");
                break;
        }
        openingDayHours = openingDayHours.replace(", [", " ");
        openingDayHours = openingDayHours.replace(", ", "-");
        openingDayHours = openingDayHours.replace("]", "");
        return openingDayHours;
    }
    //Save presences to PDF
    static exportToPDF(id) {
        var HTML_Width = jQuery(".pdf-content").width();
        var HTML_Height = jQuery(".pdf-content").height();
        var top_left_margin = 15;
        var PDF_Width = HTML_Width + (top_left_margin * 2);
        var PDF_Height = (PDF_Width * 1.5) + (top_left_margin * 2);
        var canvas_image_width = HTML_Width;
        var canvas_image_height = HTML_Height;
        var totalPDFPages = Math.ceil(HTML_Height / PDF_Height) - 1;
        html2canvas(jQuery(".pdf-content")[0]).then(function (canvas) {
            var imgData = canvas.toDataURL("image/jpeg", 1.0);
            var pdf = new jsPDF('p', 'pt', [PDF_Width, PDF_Height]);
            pdf.addImage(imgData, 'JPG', top_left_margin, top_left_margin, canvas_image_width, canvas_image_height);
            for (var i = 1; i <= totalPDFPages; i++) {
                pdf.addPage([PDF_Width, PDF_Height]);
                pdf.addImage(imgData, 'JPG', top_left_margin, -(PDF_Height * i) + (top_left_margin * 4), canvas_image_width, canvas_image_height);
            }
            pdf.save(id + ".pdf");
        });
    }
}
